// @givmo/app-admin — the DARK-gated "Give" entry point (EP-WEB1).
//
// Renders a primary "Give" action that navigates to the direct-giving create flow (`/give`) — but ONLY
// when the dark switch `isCompanyDirectGivingEnabled()` is on. While off (the default in every
// environment) it renders NOTHING, so the direct-giving flow has no visible entry point until the
// switch flips in lockstep with the backend funding flag. Mounted in the Dashboard page header.

import { useNavigate } from '@tanstack/react-router';
import { Button, Icon } from '@givmo/design-system';
import { HandHeart } from 'lucide-react';
import { isCompanyDirectGivingEnabled } from '../../lib/env';
import { useEmployerModulePaths } from '../../lib/module-paths';

export function GiveEntryButton() {
  const navigate = useNavigate();
  const paths = useEmployerModulePaths();
  if (!isCompanyDirectGivingEnabled()) return null;
  return (
    <Button
      appearance="saas"
      tone="primary"
      leadingIcon={<Icon icon={HandHeart} size={16} aria-hidden />}
      onClick={() => void navigate({ to: paths.give })}
      testId="dashboard-give"
    >
      Donate
    </Button>
  );
}
